import { useEditBankAddressForm, useEditBankAddressFormLogic } from '../model';
import { ModalComponentWrapper } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { useConfirmationModal } from '@/widgets';
import type { SavedBankAddress } from '@/entities/bank-address';
import { EditBankAddressForm } from './EditBankAddressForm';

type Props = {
  savedBankAddress: SavedBankAddress;
  onBack: () => void;
};

export const EditBankAddressModal = ({ savedBankAddress, onBack }: Props) => {
  const { t } = useTranslation();
  const { openModal, Modal: ConfirmationModal } = useConfirmationModal();

  const { form } = useEditBankAddressForm({ savedBankAddress });

  const { updateAddress, deleteAddress, isPending } =
    useEditBankAddressFormLogic({
      form,
      templateId: savedBankAddress.templateId,
      onSuccess: onBack,
      openConfirmationModal: openModal,
    });

  return (
    <ModalComponentWrapper
      title={t('savedAddresses.bankAddress.editing.title')}
      onBack={onBack}>
      <EditBankAddressForm
        form={form}
        savedBankAddress={savedBankAddress}
        updateAddress={updateAddress}
        deleteAddress={deleteAddress}
        isPending={isPending}
      />

      {ConfirmationModal}
    </ModalComponentWrapper>
  );
};
